module.exports = __webpack_public_path__ + "components/flag/static/square/jo-1eeb37c420d1274c9d58d17e60366f0e.svg";